export default "__VITE_ASSET__B74QrCLg__"